module.exports = __webpack_public_path__ + "img/avatar.865482ac.png";